import actions from '../action/service'
import CONSTANT from '../constant/service'


export default {
  actions,
  state: {
    hasMore: true,
    page: {
      type: CONSTANT.SERVICE_QUERYTYPE,
      total: 0,
      pageNum: 1,
      pageSize: 20,
    },
    questions: [],
    questionDetail: {
    }
  },
  mutations: {
    [CONSTANT.SERVICE_GETQUESTIONLIST_SUCCESS](state, { page, list }) {
      if (page.pageNum * page.pageSize > page.total) {
        state.hasMore = false
      }
      state.page = { ...state.page, page }
      state.questions = state.questions.concat(list || [])
    },
    [CONSTANT.SERVICE_GETQUESTIONLIST_ERROR](state, e) {
      // state.questions = []
    },
    [CONSTANT.SERVICE_GETQUESTIONDETAIL_SUCCESS](state, data) {
      state.questionDetail = data
    },
    [CONSTANT.SERVICE_GETQUESTIONDETAIL_ERROR](state, e) {
      state.questionDetail = {}
    },
  }
}
